import { List, ListProps, Grid } from '@mui/material';
import LogoIcon from '../../../../icons/LogoIcon';
import { S1 } from '../../../../theme';
import Box from '../../../Box';
import { mergeSX } from '../../../../services/helpers';

export interface INavigationListProps extends ListProps {}

const LOGO_ICON_HEIGHT = '38px';
const LOGO_ICON_TOP_MARGIN = '24px';
const CONTAINER_HEIGHT = `calc(100% - ${LOGO_ICON_HEIGHT} - ${LOGO_ICON_TOP_MARGIN})`;

const buildSX = () => ({
  '&.MuiList-root': {
    height: CONTAINER_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
  },
});

const NavigationList = (props: INavigationListProps) => {
  const { sx, ...restProps } = props;
  return (
    <Grid container height="100%">
      <Grid item xs={12}>
        <Box mt={LOGO_ICON_TOP_MARGIN} ml={4}>
          <LogoIcon height={LOGO_ICON_HEIGHT} width={126} color={S1} />
        </Box>
      </Grid>
      <Grid item xs={12} height={CONTAINER_HEIGHT}>
        <List sx={mergeSX(buildSX(), sx)} {...restProps} />
      </Grid>
    </Grid>
  );
};

export default NavigationList;
